// Auto-generated by scripts/prefetch-marketing-pages.mjs — DO NOT EDIT
// Generated at: 2026-09-04T12:29:58.574Z
export const MARKETING_PRO_PAGE_SLUGS = ["apps/music-band-fan-club"] as const;

export const MARKETING_PRO_PAGE_DATA: Record<string, any> = {
  "apps/music-band-fan-club": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "updated_at": 1782480949762,
      "sk": "PAGE#1782455862628",
      "post_text_color": "#ffffff",
      "page_id": 1782455862628,
      "seoKeywords": "Music band",
      "gsi1pk": "apps/music-band-fan-club/",
      "status": "PUBLISHED",
      "pk": "MARKETINGPAGE",
      "title": "Music band",
      "meta_description": "Music band",
      "text_color": "#000000",
      "meta_title": "Music band",
      "secondary_background_color": "#000000",
      "created_at": 1782455862628,
      "button_text_color": "#ffffff",
      "url": "apps/music-band-fan-club/",
      "gsi1sk": "PAGE#1782455862628",
      "background_text_color": "#ffffff",
      "type": "MARKETING_PRO",
      "background_color": "#f5f7fa",
      "sections": [
        {
          "background_color": "#161616",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1782472470233_hero_bg.png",
          "background_text_color": "#ffffff",
          "button_text_color": "#ffffff",
          "content_image": "https://cdn-www6.topfan.dev/TopFans/Home1782798290156_hero_page_.png",
          "created_at": 1782456971909,
          "cta_background_color": "#ffffff",
          "cta_link": "",
          "cta_text": "Schedule A Demo",
          "cta_text_color": "#000000",
          "heading_font_size": "large",
          "layout_id": "pro-hero-layout",
          "name": "PRO HERO",
          "page_id": 1782455862628,
          "pk": "PAGE#1782455862628",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#ffffff",
          "section_heading": "The Ultimate Fan Club Platform for {Music Artists}",
          "section_id": 1782456971909,
          "subheading": "Our membership platform for music artists simplifies how creators manage their fanbase. TopFan Pro is the ideal membership solution to build a community with monetization opportunities and data ownership. Take charge of your listener base and maximize your potential with a subscription platform designed specifically for artists.",
          "theme_color": "#7c3aed",
          "title": "Pro Hero",
          "updated_at": 1782798305400,
          "sk": "SECTION#1782456971909"
        },
        {
          "background_color": "#ffffff",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1782477990612_background_flare__1_.png",
          "background_text_color": "#1e293b",
          "button_text_color": "#faecec",
          "card_1_description": "Take back control of fan engagement and monetization from the big corporations that don’t want you to directly access your fans. Have your own financially sustainable platform that you control 100%.",
          "card_1_image": "https://cdn-www6.topfan.dev/TopFans/Home1782473237625_frame_2147226459.png",
          "card_1_title": "{Your Band’s Own Social Platform}",
          "card_2_description": "Take back control of fan engagement and monetization from the big corporations that don’t want you to directly access your fans. Have your own financially sustainable platform that you control 100%.",
          "card_2_image": "https://cdn-www6.topfan.dev/TopFans/Home1782473237625_container.png",
          "card_2_title": "{Your Band’s Own Social Platform}",
          "card_3_description": "Take back control of fan engagement and monetization from the big corporations that don’t want you to directly access your fans. Have your own financially sustainable platform that you control 100%.",
          "card_3_image": "https://cdn-www6.topfan.dev/TopFans/Home1782473237625_group_75927.png",
          "card_3_title": "{Your Band’s Own Social Platform}",
          "card_4_description": "Take back control of fan engagement and monetization from the big corporations that don’t want you to directly access your fans. Have your own financially sustainable platform that you control 100%.",
          "card_4_image": "https://cdn-www6.topfan.dev/TopFans/Home1782473237625_container_copy.png",
          "card_4_title": "{Your Band’s Own Social Platform}",
          "created_at": 1782457958482,
          "heading_font_size": "large",
          "layout_id": "pro-four-card-layout",
          "name": "FOUR CARD",
          "page_id": 1782455862628,
          "pk": "PAGE#1782455862628",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#a3a3a3",
          "section_heading": "",
          "section_id": 1782457958482,
          "theme_color": "#fff2f2",
          "title": "Four Card",
          "updated_at": 1782477993628,
          "sk": "SECTION#1782457958482"
        },
        {
          "background_color": "#373737",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1782473371959_coro_1.png",
          "background_text_color": "#ffffff",
          "button_text_color": "#ffffff",
          "content_image": null,
          "created_at": 1782459700116,
          "heading_font_size": "small",
          "layout_id": "pro-showcase-slider-layout",
          "mobile_image": null,
          "name": "CORO",
          "page_id": 1782455862628,
          "pk": "PAGE#1782455862628",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#0f172a",
          "section_heading": "",
          "section_id": 1782459700116,
          "slide_1_content_image": "https://cdn-www6.topfan.dev/TopFans/Home1782480111949_coro_1.png",
          "slide_1_heading": "The Only 100%  White-Labeled Mobile and Desktop Friendly Platform for Music Artists",
          "slide_1_mobile_image": null,
          "slide_1_subtitle": "Fully Customizable and Branded Interface",
          "slide_2_content_image": "https://cdn-www6.topfan.dev/TopFans/Home1782480111949_coro_2.png",
          "slide_2_heading": "The Only 100%  White-Labeled Mobile and Desktop Friendly Platform for Music Artists",
          "slide_2_mobile_image": null,
          "slide_2_subtitle": "Fully Customizable and Branded Interface",
          "slide_3_content_image": "https://cdn-www6.topfan.dev/TopFans/Home1782480111949_coro_3.png",
          "slide_3_heading": "The Only 100%  White-Labeled Mobile and Desktop Friendly Platform for Music Artists",
          "slide_3_mobile_image": null,
          "slide_3_subtitle": "Fully Customizable and Branded Interface",
          "slide_4_content_image": "https://cdn-www6.topfan.dev/TopFans/Home1782480111949_coro_4.png",
          "slide_4_heading": "The Only 100%  White-Labeled Mobile and Desktop Friendly Platform for Music Artists",
          "slide_4_mobile_image": null,
          "slide_4_subtitle": "Fully Customizable and Branded Interface",
          "slide_5_content_image": "https://cdn-www6.topfan.dev/TopFans/Home1782480111949_coro_5.png",
          "slide_5_heading": "The Only 100%  White-Labeled Mobile and Desktop Friendly Platform for Music Artists",
          "slide_5_mobile_image": null,
          "slide_5_subtitle": "Fully Customizable and Branded Interface",
          "slide_6_content_image": "https://cdn-www6.topfan.dev/TopFans/Home1782480111949_coro_6.png",
          "slide_6_heading": "The Only 100%  White-Labeled Mobile and Desktop Friendly Platform for Music Artists",
          "slide_6_mobile_image": null,
          "slide_6_subtitle": "Fully Customizable and Branded Interface",
          "slide_7_content_image": null,
          "slide_7_heading": "",
          "slide_7_mobile_image": null,
          "slide_7_subtitle": "",
          "subtitle": "",
          "theme_color": "#7c3aed",
          "title": "Coro",
          "updated_at": 1782480144981,
          "sk": "SECTION#1782459700116"
        },
        {
          "background_color": "#000000",
          "background_image": null,
          "background_text_color": "#ffffff",
          "button_text_color": "#ffffff",
          "created_at": 1782460190950,
          "heading_font_size": "large",
          "layout_id": "pro-comparison-table-layout",
          "name": "COMPARE",
          "page_id": 1782455862628,
          "pk": "PAGE#1782455862628",
          "post_text_color": "#ffffff",
          "row_1_feature": "Your own fully branded website and optional iOS & Android app",
          "row_1_icon": null,
          "row_1_others": "false",
          "row_1_topfan": "true",
          "row_2_feature": "",
          "row_2_icon": null,
          "row_2_others": "",
          "row_2_topfan": "",
          "row_3_feature": "",
          "row_3_icon": null,
          "row_3_others": "",
          "row_3_topfan": "",
          "row_4_feature": "",
          "row_4_icon": null,
          "row_4_others": "",
          "row_4_topfan": "",
          "row_5_feature": "",
          "row_5_icon": null,
          "row_5_others": "",
          "row_5_topfan": "",
          "row_6_feature": "",
          "row_6_icon": null,
          "row_6_others": "",
          "row_6_topfan": "",
          "secondary_background_color": "#000000",
          "section_description": "Our fan club platform for music artists helps you maintain a vibrant community that stays engaged long after each new release. Keep listener interest high between releases with interactive features and a steady stream of exclusive behind-the-scenes content, offering a visual experience that complements your music and deepens your connection with your audience. If you own your masters, you can securely stream music directly to fans, or if not, you can use our Spotify and Apple Music API integrations to create customized playlists for your fans to listen to directly inside your personal iOS and Android app.",
          "section_heading": "How TopFan compare to other Artist fan club solutions",
          "section_id": 1782460190950,
          "theme_color": "#7c3aed",
          "title": "Compare",
          "updated_at": 1782477839811,
          "sk": "SECTION#1782460190950"
        },
        {
          "background_color": "#f5f7fa",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1782478016107_background_flare__1_.jpg",
          "background_text_color": "#1e293b",
          "button_text_color": "#ffffff",
          "created_at": 1782465843351,
          "creator_poster_1_cta_1": "",
          "creator_poster_1_cta_1_url": "",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_1_description": "Our fan club platform for music artists helps you maintain a vibrant community that stays engaged long after each new release. Keep listener interest high between releases with interactive features and a steady stream of exclusive behind-the-scenes content, offering a visual experience that complements your music and deepens your connection with your audience.",
          "creator_poster_1_heading_position": "left",
          "creator_poster_1_image": "https://cdn-www6.topfan.dev/TopFans/Home1782474345987_beyond.png",
          "creator_poster_1_title": "[Beyond the Album Release]",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www6.topfan.dev/TopFans/Home1782474345987_beyond.png",
              "cta_1_url": null,
              "heading_position": "left",
              "cta_2_url": null,
              "description": "Our fan club platform for music artists helps you maintain a vibrant community that stays engaged long after each new release. Keep listener interest high between releases with interactive features and a steady stream of exclusive behind-the-scenes content, offering a visual experience that complements your music and deepens your connection with your audience.",
              "cta_2": null,
              "cta_1": null,
              "title": "[Beyond the Album Release]"
            }
          ],
          "heading_font_size": "medium",
          "include_highlighted_border": "true",
          "layout_id": "creator-poster-layout",
          "name": "CREATOR POST LAYOUT",
          "page_id": 1782455862628,
          "pk": "PAGE#1782455862628",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#0f172a",
          "section_heading": "",
          "section_id": 1782465843351,
          "subheading": "",
          "theme_color": "#7c3aed",
          "title": "Creator Post Layout",
          "updated_at": 1782478017969,
          "sk": "SECTION#1782465843351"
        },
        {
          "background_color": "#f5f7fa",
          "background_image": null,
          "background_text_color": "#1e293b",
          "button_text_color": "#ffffff",
          "created_at": 1782466478736,
          "heading_font_size": "medium",
          "key_win_1_description": "Provide exclusive perks to paying members, showing them that their support is valued and encouraging continued subscriptions.",
          "key_win_1_icon": "https://cdn-www6.topfan.dev/TopFans/Home1782474024086_inn_1.png",
          "key_win_1_title": "Subscription Model",
          "key_win_2_description": "Offer behind-the-scenes access and unique content that listeners can’t find elsewhere, satisfying their desire for a closer look at your creative process.",
          "key_win_2_icon": "https://cdn-www6.topfan.dev/TopFans/Home1782474024086_inn_2.png",
          "key_win_2_title": "Exclusive Content",
          "key_win_3_description": "Offer behind-the-scenes access and unique content that listeners can’t find elsewhere, satisfying their desire for a closer look at your creative process.",
          "key_win_3_icon": "https://cdn-www6.topfan.dev/TopFans/Home1782474024086_inn_3.png",
          "key_win_3_title": "Exclusive Content",
          "key_win_4_description": "Offer behind-the-scenes access and unique content that listeners can’t find elsewhere, satisfying their desire for a closer look at your creative process.",
          "key_win_4_icon": "https://cdn-www6.topfan.dev/TopFans/Home1782474024086_inn_4.png",
          "key_win_4_title": "Exclusive Content",
          "key_win_5_description": "Offer behind-the-scenes access and unique content that listeners can’t find elsewhere, satisfying their desire for a closer look at your creative process.",
          "key_win_5_icon": "https://cdn-www6.topfan.dev/TopFans/Home1782474024086_inn_5.png",
          "key_win_5_title": "Exclusive Content",
          "key_win_6_description": "",
          "key_win_6_icon": null,
          "key_win_6_title": "",
          "layout_id": "comparison-key-wins-layout",
          "name": "INNOVATIVE FAN",
          "page_id": 1782455862628,
          "pk": "PAGE#1782455862628",
          "post_text_color": "#040404",
          "secondary_background_color": "#0f172a",
          "section_heading": "Innovative  Fan Monetization Strategies",
          "section_id": 1782466478736,
          "subheading": "TopFan Pro’s membership platform for music artists unlocks a variety of revenue streams to enhance your profitability and sustain listener engagement. By diversifying your offerings, you can create a more profitable and enduring connection with your audience.",
          "theme_color": "#7c3aed",
          "title": "Innovative Fan",
          "updated_at": 1782474028102,
          "sk": "SECTION#1782466478736"
        },
        {
          "background_color": "#f5f7fa",
          "background_image": "https://cdn-www6.topfan.dev/TopFans/Home1782478035458_background_flare__1_.jpg",
          "background_text_color": "#1e293b",
          "button_text_color": "#ffffff",
          "created_at": 1782466613665,
          "creator_poster_1_cta_1": "",
          "creator_poster_1_cta_1_url": "",
          "creator_poster_1_cta_2": "",
          "creator_poster_1_cta_2_url": "",
          "creator_poster_1_description": "On our fan club platform for music artists, you will find the insights you need to enhance listener engagement and boost revenue. By analyzing metrics related to music fan behavior and purchasing patterns, you can uncover new opportunities for monetization.\nMusic Artists have leveraged TopFan Pro’s data-driven insights to launch targeted campaigns that drive greater loyalty and increased spending. With our platform, you’ll have the tools to make informed decisions and maximize the lifetime value of your listeners.",
          "creator_poster_1_heading_position": "right",
          "creator_poster_1_image": "https://cdn-www6.topfan.dev/TopFans/Home1782474882568_data_driven.png",
          "creator_poster_1_title": "[Data-Driven Strategies for Maximum ROI]",
          "creator_poster_cards": [
            {
              "image": "https://cdn-www6.topfan.dev/TopFans/Home1782474882568_data_driven.png",
              "cta_1_url": null,
              "heading_position": "right",
              "cta_2_url": null,
              "description": "On our fan club platform for music artists, you will find the insights you need to enhance listener engagement and boost revenue. By analyzing metrics related to music fan behavior and purchasing patterns, you can uncover new opportunities for monetization.\nMusic Artists have leveraged TopFan Pro’s data-driven insights to launch targeted campaigns that drive greater loyalty and increased spending. With our platform, you’ll have the tools to make informed decisions and maximize the lifetime value of your listeners.",
              "cta_2": null,
              "cta_1": null,
              "title": "[Data-Driven Strategies for Maximum ROI]"
            }
          ],
          "heading_font_size": "medium",
          "include_highlighted_border": "true",
          "layout_id": "creator-poster-layout",
          "name": "DATA DRIVEN",
          "page_id": 1782455862628,
          "pk": "PAGE#1782455862628",
          "post_text_color": "#ffffff",
          "secondary_background_color": "#0f172a",
          "section_heading": "",
          "section_id": 1782466613665,
          "subheading": "",
          "theme_color": "#7c3aed",
          "title": "Data Driven",
          "updated_at": 1782478037233,
          "sk": "SECTION#1782466613665"
        },
        {
          "background_color": "#f5f7fa",
          "background_image": null,
          "background_text_color": "#000000",
          "button_text_color": "#e5e5e5",
          "created_at": 1782466728762,
          "creator_1_image": "https://cdn-www6.topfan.dev/TopFans/Home1782475090417_max.png",
          "creator_1_link": "app/max-mcnown/",
          "creator_1_name": "Max McNown",
          "creator_2_image": "https://cdn-www6.topfan.dev/TopFans/Home1782475090417_roob.png",
          "creator_2_link": "app/max-mcnown/",
          "creator_2_name": "Tool Army",
          "creator_3_image": "https://cdn-www6.topfan.dev/TopFans/Home1782475090417_undead.png",
          "creator_3_link": "app/max-mcnown/",
          "creator_3_name": "Hollywood Undead",
          "creator_4_image": "https://cdn-www6.topfan.dev/TopFans/Home1782475090417_house_of_jade.png",
          "creator_4_link": "app/max-mcnown/",
          "creator_4_name": "House Of Jade",
          "creator_5_image": null,
          "creator_5_link": "",
          "creator_5_name": "",
          "creator_6_image": null,
          "creator_6_link": "",
          "creator_6_name": "",
          "creator_7_image": null,
          "creator_7_link": "",
          "creator_7_name": "",
          "creator_8_image": null,
          "creator_8_link": "",
          "creator_8_name": "",
          "creator_name_bg_color": "#f16800",
          "creator_name_text_color": "#ffffff",
          "cta_background_color": "#0d0d0d",
          "cta_link": "",
          "cta_text": "Schedule A Demo",
          "cta_text_color": "#ffffff",
          "heading_font_size": "large",
          "layout_id": "pro-creator-grid-layout",
          "name": "EXPLORE MUSIC ARTIST",
          "page_id": 1782455862628,
          "pk": "PAGE#1782455862628",
          "post_text_color": "#000000",
          "secondary_background_color": "#0f172a",
          "section_heading": "{Explore Music Artist Communities Powered by TopFan Pro}",
          "section_id": 1782466728762,
          "subtitle": "Available for free on iPhone, iPad, Android and the Web",
          "theme_color": "#7c3aed",
          "title": "Explore Music Artist",
          "updated_at": 1782746790005,
          "sk": "SECTION#1782466728762"
        },
        {
          "subheading": "",
          "button_text_color": "",
          "created_at": 1784291968174,
          "background_color": "",
          "heading_font_size": "medium",
          "poster_url": null,
          "background_text_color": "",
          "video_url": null,
          "theme_color": "",
          "background_image": null,
          "updated_at": 1784291968174,
          "page_id": 1782455862628,
          "post_text_color": "",
          "layout_id": "image-carousel-layout",
          "section_id": 1784291968174,
          "cta_link": "",
          "section_heading": "",
          "carousel_images": [],
          "secondary_background_color": "",
          "pk": "PAGE#1782455862628",
          "cta_text": "",
          "title": "hi",
          "sk": "SECTION#1784291968174"
        }
      ]
    }
  }
};
